<template>
  <section id="menu" :class="[$mq]">
    <div class="list" ref="list">
      <div
        v-for="(item, index) in menu"
        v-if="index < parseInt((headerWidth - 950) / 90)"
        class="item"
        :class="{
          selected: path.startsWith(item.url),
          disabled: item.disabled,
        }"
      >
        <router-link :to="item.url" :event="item.disabled ? '' : 'click'">
          <img class="img" :src="item.img" />
          <div class="content">{{ $t(item.name) }}</div>
        </router-link>
      </div>
      <div
        class="item more"
        v-if="menu.length > parseInt((headerWidth - 950) / 90)"
        @click="show_menu = !show_menu"
      >
        <img class="img" src="/img/menu.svg" />
      </div>
    </div>

    <div class="menu-other" v-if="show_menu">
      <div
        v-for="(item, index) in menu"
        v-if="index >= parseInt((headerWidth - 950) / 90)"
        class="item"
        :class="{ selected: item.url === path }"
        @click="show_menu = !show_menu"
      >
        <router-link :to="item.url" :event="item.disabled ? '' : 'click'">
          <img class="img" :src="item.img" />
          <div class="content">{{ $t(item.name) }}</div>
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
import i18n from "@/i18n";

export default {
  props: { headerWidth: Number },
  data() {
    return {
      show_menu: false,
    };
  },
  computed: {
    path() {
      // console.log("path: "+ this.$route.path);
      return this.$route.path;
    },

    menu() {
      var oEvent = this.$store.getters["events/getCurrentEvent"]();
      // console.log( typeof oEvent );
      var event_url =
        this.$store.getters.isEventSelected &&
        typeof oEvent.name !== "undefined"
          ? this.$root.formatEventUrl(oEvent.name, oEvent.edition)
          : "";
      if (this.$store.getters.isEventSelected && !oEvent.is_campus) {
        return [
          {
            url: event_url + "/club",
            name: "clubs.label",
            img: "/img/club_2.svg",
          },
          {
            url: event_url + "/team",
            name: "teams.label",
            img: "/img/team2.svg",
          },
          {
            url: event_url + "/competition",
            name: "competition.label",
            img: "/img/competition.svg",
          },
          {
            url: event_url + "/person",
            name: "persons.label",
            img: "/img/users.svg",
          },
          {
            url: event_url + "/volunteer",
            name: "volunteers.label",
            img: "/img/users.svg",
          },
          {
            url: event_url + "/hotel",
            name: "hotels.label",
            img: "/img/hotel.svg",
          },
          {
            url: event_url + "/facility",
            name: "facilitys.label",
            img: "/img/court.svg",
          },
          {
            url: event_url + "/travel",
            name: "travels.label",
            img: "/img/bus.svg",
          },
          {
            url: event_url + "/finances",
            name: "finances.label",
            img: "/img/finance.svg",
          },
          {
            url: event_url + "/settings",
            name: "settings.label",
            img: "/img/settings.svg",
          },
          {
            url: event_url + "/confirmations",
            name: "title_hotel_confirmations",
            img: "/img/hotel_app.svg",
          }
          // {url: event_url + '/documentation', name: 'documentation.label', img: '/img/book.svg'},
        ];
      } else if (oEvent.is_campus) {
        return [
          {
            url: event_url + "/person",
            name: "persons.label",
            img: "/img/users.svg",
          },
          {
            url: event_url + "/volunteer",
            name: "volunteers.label",
            img: "/img/users.svg",
          },
          {
            url: event_url + "/participants",
            name: "participants.label",
            img: "/img/users.svg",
          },
          {
            url: event_url + "/hotel",
            name: "hotels.label",
            img: "/img/hotel.svg",
          },
          {
            url: event_url + "/facility",
            name: "facilitys.label",
            img: "/img/court.svg",
          },
          {
            url: event_url + "/travel",
            name: "travels.label",
            img: "/img/bus.svg",
          },
          {
            url: event_url + "/finances",
            name: "finances.label",
            img: "/img/finance.svg",
          },
          // {url: event_url + '/documentation', name: 'documentation.label', img: '/img/book.svg'},
        ];
      } else {
        return [
          {
            url: event_url + "/club",
            name: "clubs.label",
            img: "/img/club_2.svg",
          },
          {
            url: event_url + "/event",
            name: "events.label",
            img: "/img/event.svg",
          },
          {
            url: event_url + "/person",
            name: "persons.label",
            img: "/img/users.svg",
          },
          {
            url: event_url + "/volunteer",
            name: "volunteers.label",
            img: "/img/users.svg",
          },
          {
            url: event_url + "/hotel",
            name: "hotels.label",
            img: "/img/hotel.svg",
          },
          {
            url: event_url + "/facility",
            name: "facilitys.label",
            img: "/img/court.svg",
          },
        ];
      }
    },
    // other(){
    //   var oEvent = this.$store.getters[ "events/getCurrentEvent" ]();
    //   //console.log( typeof oEvent );
    //   var event_url = ( this.$store.getters.isEventSelected && typeof oEvent.name !== 'undefined' )? this.$root.formatEventUrl( oEvent.name, oEvent.edition ) : '';
    //   return [
    //     {url: event_url + '/facility', name: 'facilitys.label', img: '/img/court.svg'},
    //     {url: event_url + '/bus', name: 'buses.label', img: '/img/bus.svg'},
    //     {url: event_url + '/economy', name: 'economy.label', img: '/img/finance.svg'},
    //     // {url: event_url + '/config', name: 'config.label', img: '/img/config.svg', disabled: true},
    //   ]
    // }
  },
  methods: {
    select(item) {
      if (!item.disabled) {
        for (var k in this.menu) {
          this.menu[k].selected = false;
        }
        item.selected = true;
        this.$store.commit("setMenuVisible", false);
        // this.$store.commit('setSearch', '');
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#menu {
  width: 100%;
  padding: 0px;
  position: relative;
  overflow: hidden;
  border-right: 1px solid #fff1;
  margin-right: 15px;

  .menu-other {
    position: fixed;
    top: 94px;
    background: #0d122d;
    z-index: 15;
    right: 460px;
    padding: 10px 0;

    .item {
      padding: 10px 20px;
      text-align: left;
      color: #fff8;
      font-size: 14px;
      overflow: hidden;
      opacity: 0.5;
      margin: 5px 0;

      .img {
        width: 20px;
        height: 20px;
        display: inline-block;
        float: left;
      }
      .content {
        display: inline-block;
        float: left;
        width: calc(100% - 20px);
        color: #fff;
        padding-left: 5px;
      }
      &:hover {
        opacity: 1;
      }
    }
  }

  .list {
    padding: 0px;

    .item {
      display: inline-block;
      color: #fff;
      text-align: center;
      padding: 12px;
      height: 65px;
      opacity: 0.5;
      float: left;
      cursor: pointer;
      width: 80px;
      overflow: hidden;

      &.more {
        padding: 20px 12px;
      }

      &:nth-child(n + 5) {
        //display: none;
      }

      &.disabled {
        opacity: 0.5;
        cursor: not-allowed;
        pointer-events: none;
        -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
        filter: grayscale(100%);

        .img {
        }
      }
      &.selected {
        opacity: 1;
        background-color: rgba(255, 255, 255, 0.5);

        .content {
          //font-weight: bold;
        }
      }
      &:hover {
        //  border-bottom: 5px solid #fff;
        opacity: 1;

        .content {
        }
      }
      .img {
        width: 30px;
        height: 30px;
        display: block;
        margin: 0 auto;
      }
      .content {
        display: inline-block;
        padding: 0px;
        text-align: center;
        font-weight: lighter;
        color: #fff;
        text-transform: uppercase;
        font-size: 10px;
        margin: 0px 0px;
        width: 100%;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .search {
        margin-top: -5px;
      }
    }
  }
}

#menu.portrait {
  .menu-other {
    position: fixed;
    top: 60px;
    background: #0d122d;
    z-index: 90;
    right: 460px;
    padding: 10px 0;
    left: 0;
    width: 100%;
  }
}
</style>
